export default "__VITE_ASSET__BNWS4YXC__"